export default function ensureDefined<T>(obj: T | null | undefined): T {
  if (obj == null) {
    throw typeof obj === undefined ? new Error('object is undefined.') : new Error('object is null.');
  }
  return obj;
}
